import type { JSX } from 'react'

import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { LabelAclBlockedCardSC } from './AclBlockedLabel.styled'

export const LabelAclBlockedCard = (): JSX.Element => (
  <LabelAclBlockedCardSC>
    <Icon
      name={IconNames.geoblock}
      color={Colors.TEXT_ICON_SECONDARY}
      size={IconSizes.smLarge}
    />
  </LabelAclBlockedCardSC>
)
